import { workflowsApi } from "@circle-react/api/workflowsApi";
import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

type UsageStatsResponse = Awaited<
  ReturnType<typeof workflowsApi.fetchCommunityCurrentUsageStats>
>;

export const useCommunityCurrentUsageStats = (
  queryOptions: Omit<
    UseQueryOptions<UsageStatsResponse, unknown, UsageStatsResponse, string[]>,
    "queryKey" | "queryFn"
  > = {},
) =>
  useQuery({
    queryKey: ["workflows-community-current-usage-stats"],
    queryFn: () => workflowsApi.fetchCommunityCurrentUsageStats(),
    ...queryOptions,
  });
